// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__EIRAC","info":"PatientInfo_info__excLR"};